'use client';
import type { LogsInitConfiguration } from '@datadog/browser-logs';
import { datadogLogs } from '@datadog/browser-logs';

import type { PerformSafeLogRepository } from '../../domain';

let currentDatadogLogs: typeof datadogLogs | null = null;

export const datadogBrowserLogAdapter: (
  config: LogsInitConfiguration,
) => PerformSafeLogRepository = (config) => {
  if (!currentDatadogLogs) {
    datadogLogs.init({
      allowUntrustedEvents: true,
      forwardErrorsToLogs: false,
      sessionSampleRate: 100,
      silentMultipleInit: true,
      telemetrySampleRate: 0,
      trackSessionAcrossSubdomains: true,
      ...config,
      beforeSend: (event) => {
        if (
          event.status === 'error' &&
          typeof event.error?.message === 'string' &&
          event.error.message.includes('NEXT_REDIRECT') // discard errors when calling next/navigation.redirect
        ) {
          return false;
        }
        return true;
      },
    });

    currentDatadogLogs = datadogLogs;
  }

  return (log) => {
    if (log.type === 'error') {
      const context = {
        ...log.data,
      };
      context.source = log.context;
      const rootCause = context?.rootCause as Error;
      delete context?.rootCause;

      datadogLogs.logger.error(log.message, context, rootCause);
    } else datadogLogs.logger[log.type](log.message, log.data);

    return Promise.resolve();
  };
};
